
const useUtils = () => {
  const generateLetter = () => {
    var letras = [
      "a",
      "b",
      "c",
      "d",
      "e",
      "f",
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
    ];
    let numero = (Math.random() * 15).toFixed(0);
    return letras[numero];
  };

  const colorHEX = () => {
    let color = "";
    for (let i = 0; i < 6; i++) {
      color = color + generateLetter();
    }
    return "#" + color;
  };

  return {
    colorHEX
  }
};

export default useUtils;
